import './styles/quasar.sass'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'
import Quasar from 'quasar/src/vue-plugin.js';

// Import Quasar language packs
import langEn from 'quasar/lang/en-US'
import langRu from 'quasar/lang/ru'

// Get saved locale from localStorage or use default
const savedLocale = localStorage.getItem('locale') || 'uz'

// Map our locales to Quasar language packs
const quasarLangMap = {
  'uz': langRu, // Use Russian for Uzbek (closest available)
  'uz-crl': langRu, // Use Russian for Uzbek Cyrillic
  'en': langEn,
  'ru': langRu
}

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {},
  lang: quasarLangMap[savedLocale] || langRu
}